var exports = {
  "x": "x04b3a21e--e52310--button",
};

module.exports = exports;
